import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { message } from "antd";
import { useMutation } from "react-query";
import userManagementService from "../../logic/userManagementService";
import useUserManagement from "../../logic/useUserManagement";

const useModalEditUser = (
  userData,
  openEditModalUser,
  setOpenEditModalUser
) => {
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
    register,
    watch,
  } = useForm();

  const { refetchUsers } = useUserManagement();

  useEffect(() => {
    if (userData) {
      setValue("firstName", userData?.firstName);
      setValue("lastName", userData?.lastName);
      setValue("email", userData?.email);
      setValue("title", userData?.title);
      setValue("telephone", userData?.telephone);
      setValue("roles", userData?.roles?.map((role) => role));
      console.log('userData?.department', userData?.department);
      setValue("department", userData?.department);
    }
  }, [userData, setValue, watch]);

  const listRoles = [
    { value: "Admin", label: "Admin" },
    { value: "Editor", label: "Editor" },
    { value: "Trainer", label: "Trainer" },
    { value: "Trainee", label: "Trainee" },
    { value: "DivisionManager", label: "Division Manager" },
    { value: "Project Manager", label: "Project Manager" },
    { value: "Team Leader", label: "Team Lead" },
  ];

  const listDepartments = [
    { value: "HR", label: "HR" },
    { value: "Engineering", label: "Engineering" },
    { value: "Marketing", label: "Marketing" },
    { value: "Sales", label: "Sales" },
    { value: "Finance", label: "Finance" },
  ];

  const handleCancel = () => {
    reset();
    setOpenEditModalUser(!openEditModalUser);
  };

  const updateUserRolesMutation = useMutation(
    (formData) => userManagementService.updateRolesUser(userData?.id, formData),
    {
      onSuccess: async () => {
        try {
          await refetchUsers();
          handleCancel();
          message.success("User updated successfully");
        } catch (error) {
          console.error("Error updating user:", error);
          message.error("Failed to update user");
        }
      },
      onError: (error) => {
        console.error("Error updating user:", error);
        message.error("Failed to update user");
      },
    }
  );

  const onUpdateUser = () => {
    const formData = {
      roles: watch("roles"),
      telephone: watch("telephone"),
      title: watch("title"),
      department: watch("department"), // exclude department because it doesn't exist in the database yet
    };
    console.log('formData', formData);
    updateUserRolesMutation.mutate(formData);
  };

  return {
    handleSubmit,
    control,
    reset,
    setValue,
    errors,
    register,
    watch,
    listRoles,
    listDepartments, // Return listDepartments
    onUpdateUser,
    handleCancel,
  };
};

export default useModalEditUser;
